module.exports = __webpack_public_path__ + "media/images/bg/timer-vector-6dd948193f89c0a6add7e1a57c4b8907.png";